import { render, staticRenderFns } from "./InfoBar.vue?vue&type=template&id=13c50c6d&scoped=true"
import script from "./InfoBar.vue?vue&type=script&lang=js"
export * from "./InfoBar.vue?vue&type=script&lang=js"
import style0 from "./InfoBar.vue?vue&type=style&index=0&id=13c50c6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c50c6d",
  null
  
)

export default component.exports